class VDCleanNavigation extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.triggers = [...this.querySelectorAll('[data-vd-nav-trigger]')];
    this.active = null;
    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => this.active === trigger ? this.close() : this.open(trigger), options);
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); this.open(trigger);
          document.getElementById(trigger.getAttribute('aria-controls'))?.querySelector('a')?.focus();
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          this.triggers[(index + step + this.triggers.length) % this.triggers.length]?.focus();
        }
      }, options);
    });
    this.querySelectorAll('[data-vd-close]').forEach(button => button.addEventListener('click', () => this.close(true), options));
    document.addEventListener('click', event => { if (!this.contains(event.target)) this.close(); }, options);
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && this.active) { event.preventDefault(); this.close(true); } }, options);
    this.addEventListener('pointerdown', event => {
      const link = event.target.closest('a[href]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(link.href);
    }, { ...options, capture: true });
    window.addEventListener('resize', () => this.close(), options);
    window.addEventListener('scroll', () => { if (this.active) this.position(); }, { ...options, passive: true });
  }
  position() {
    const header = this.closest('header-component');
    const bottom = header?.getBoundingClientRect().bottom ?? this.getBoundingClientRect().bottom;
    this.style.setProperty('--vd-panel-top', `${Math.max(0, Math.round(bottom))}px`);
  }
  open(trigger) {
    this.close(); this.position();
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    this.querySelector('.vd-nav__backdrop').hidden = false;
    this.active = trigger;
  }
  close(returnFocus = false) {
    const last = this.active;
    this.querySelectorAll('.vd-nav__panel').forEach(panel => { panel.hidden = true; });
    this.triggers?.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    const backdrop = this.querySelector('.vd-nav__backdrop');
    if (backdrop) backdrop.hidden = true;
    this.active = null;
    if (returnFocus) last?.focus();
  }
  disconnectedCallback() { this.close(); this.abort?.abort(); }
}
if (!customElements.get('vd-navigation')) customElements.define('vd-navigation', VDCleanNavigation);
